var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtistsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 10.875,
    fill: "#1B1B1B",
    stroke: "#1B1B1B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4, 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0365 3.03178C4.91503 2.99663 4.78745 2.99131 4.6637 3.01621C4.53995 3.04112 4.42337 3.09559 4.32306 3.17537C4.22275 3.25515 4.14141 3.35809 4.08541 3.47616C4.0294 3.59422 4.00023 3.72421 4.00018 3.85601V7.94067C3.99096 8.94651 4.34352 9.91932 4.98795 10.6661C5.87708 11.6829 6.98401 12.4648 8.218 12.9477C8.3999 13.0174 8.59955 13.0174 8.78144 12.9477C10.0157 12.4652 11.1229 11.6832 12.012 10.6661C12.6565 9.91932 13.009 8.94651 12.9998 7.94067V3.85601C12.9999 3.7239 12.9707 3.59357 12.9145 3.47523C12.8584 3.35689 12.7768 3.25377 12.6761 3.17392C12.5754 3.09408 12.4585 3.0397 12.3344 3.01504C12.2103 2.99038 12.0824 2.99611 11.9608 3.03178C9.69784 3.70711 7.29941 3.70711 5.0365 3.03178Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2847 8C2.18052 7.9055 2.08125 7.81157 1.98797 7.71861C1.34353 7.06421 0.990958 6.21184 1.00018 5.33047V1.75079C0.999997 1.63474 1.02922 1.52025 1.08553 1.41631C1.14185 1.31238 1.22372 1.22184 1.32471 1.15183C1.4257 1.08182 1.54305 1.03424 1.66751 1.01285C1.79198 0.991457 1.92016 0.996832 2.04197 1.02855C4.30401 1.62034 6.70161 1.62034 8.96365 1.02855C9.08511 0.997754 9.21269 0.993087 9.33646 1.01491C9.46022 1.03674 9.57681 1.08447 9.67711 1.15437C9.7774 1.22428 9.85874 1.31448 9.91478 1.41794C9.97077 1.52139 9.99995 1.6353 10 1.75079V2.62547",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9C7.00706 9.26343 7.16428 9.51503 7.43914 9.70165C7.72049 9.8927 8.10211 10 8.5 10C8.89789 10 9.27946 9.8927 9.56086 9.70165C9.83572 9.51503 9.99294 9.26343 10 9",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6C6.00202 6 6.05445 6 6.14639 6C6.24019 6 6.36737 6 6.5 6C6.63263 6 6.75981 6 6.85361 6C6.94555 6 6.99798 6 7 6",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6C10.0032 6 10.0555 6 10.1463 6C10.2401 6 10.3673 6 10.5 6C10.6327 6 10.7599 6 10.8537 6C10.9445 6 10.9968 6 11 6",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistsActive);
export default __webpack_public_path__ + "static/media/artists-active.2eb5033551b48c7e0d95617dec5655d7.svg";
export { ForwardRef as ReactComponent };